import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pl-1 text-sm"
}
const _hoisted_2 = { class: "dropdown-scrollbar absolute left-0 z-30 max-h-36 w-full overflow-y-auto overflow-x-hidden bg-white shadow-lg lg:max-h-44" }

import { onBeforeUnmount, onMounted, ref, withDefaults } from 'vue';
import LzIcon from './LzIcon.vue';
import { DropdownItem } from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'LzDropdown',
  props: {
    title: { default: '' },
    required: { type: Boolean, default: false },
    activeTitleClasses: { default: '' }
  },
  emits: ['change'],
  setup(__props: any, { emit }) {

const props = __props;




const visible = ref(false);
const root = ref<HTMLElement | null>(null);
const activeTitle = ref('');
const activeValue = ref('');

onMounted(() => {
    document.addEventListener('click', onOutsideClicked);
});

onBeforeUnmount(() => {
    document.removeEventListener('click', onOutsideClicked);
});

function select(item: DropdownItem) {
    if (item.value === activeValue.value) {
        activeValue.value = '';
        activeTitle.value = '';
        emit('change', '');
        return;
    }
    activeTitle.value = item.label;
    activeValue.value = item.value;
    visible.value = false;
    emit('change', activeValue.value);
}

function onOutsideClicked(event: MouseEvent) {
    let target = event.target as Node;
    do {
        if (target === root.value) {
            return;
        }
        target = target.parentNode as Node;
    } while (target);
    visible.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_collapse_transition = _resolveComponent("collapse-transition")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "input", { value: activeValue.value }),
    _createElementVNode("div", {
      ref_key: "root",
      ref: root,
      class: "relative mb-2 border-b border-black"
    }, [
      _createElementVNode("div", {
        class: "mt-4 flex cursor-pointer items-center justify-between py-1",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = !visible.value))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["-mt-1 origin-left transition-transform", !!activeValue.value ? 'mt-0 -translate-y-full scale-75 pb-0' : 'pb-1'])
        }, [
          _createTextVNode(_toDisplayString(_ctx.title), 1),
          (_ctx.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, "*"))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("span", {
          class: _normalizeClass(["absolute w-full pr-4 line-clamp-1", _ctx.activeTitleClasses])
        }, _toDisplayString(activeTitle.value || ' '), 3),
        _createVNode(LzIcon, {
          name: "chevron",
          class: _normalizeClass(["h-3 w-3 stroke-current transition-transform duration-300", visible.value ? '-rotate-90' : 'rotate-90'])
        }, null, 8, ["class"])
      ])
    ], 512),
    _withDirectives(_createVNode(_component_collapse_transition, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default", { select: select })
        ])
      ]),
      _: 3
    }, 512), [
      [_vShow, visible.value]
    ])
  ], 64))
}
}

})